// extracted by mini-css-extract-plugin
export default {"problem":"Problem_problem__+gCAV","buttonContainer":"Problem_buttonContainer__0KTzn","uploaded":"Problem_uploaded__BvkyR","footer":"Problem_footer__67Pm2"};